import { css } from "@compiled/react";

export interface ColumnHeaderProps {
    label: string;
    sortable: boolean;
    sortDirection?: "asc" | "desc";
    onClick?: () => void;
}

export const ColumnHeader = (props: ColumnHeaderProps) => {
    const { label, sortable, sortDirection, onClick } = props;

    const sortSymbol =
        sortDirection === "asc" ? "↑" : sortDirection === "desc" ? "↓" : "";

    return (
        <div css={headerCellCss}>
            <button
                css={headerButtonCss}
                onClick={onClick}
                data-event="clicked"
                data-event-component="button"
                data-event-container="roadmap"
            >
                <span css={labelTextCss}>{label}</span>
                {sortable && (
                    <span css={sortIconWrapperCss}>
                        {sortSymbol ?? <span css={sortIconPlaceholderCss} />}
                    </span>
                )}
            </button>
        </div>
    );
};

const headerCellCss = css({
    fontWeight: 600,
    whiteSpace: "nowrap",
    textAlign: "left",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px"
});

const labelTextCss = css({
    lineHeight: 1.2,
    fontSize: "16px"
});

const headerButtonCss = css({
    "padding": 0,
    "margin": 0,
    "border": "none",
    "background": "none",
    "display": "inline-flex",
    "alignItems": "center",
    "gap": "4px",
    "font": "inherit",
    "color": "inherit",
    "cursor": "pointer",
    "&:hover": {
        cursor: "pointer"
    }
});

const sortIconWrapperCss = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "12px",
    height: "12px",
    fontSize: "16px"
});

const sortIconPlaceholderCss = css({
    display: "inline-block",
    width: "8px",
    height: "8px"
});
